import api from "@/apis/bussiness/rssAPI";
import Crud from "./crudBase";
var crud = new Crud("rss", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "key",
      code: "key",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
